import styled from 'styled-components'
import ProBadgeWhiteTransparent from 'images/ProBadgeWhiteTransparent.png'

export const ProImage = styled.img.attrs({
	src: ProBadgeWhiteTransparent,
})`
	height: 30px;
    display: block;
    margin: auto;
`
